export const START_FETCHING_TRANSLATIONS = 'START_FETCHING_TRANSLATIONS';
export const ERROR_FETCHING_TRANSLATIONS = 'ERROR_FETCHING_TRANSLATIONS';
export const FETCHING_TRANSLATIONS = 'FETCHING_TRANSLATIONS';
export const SAVE_TRANSLATIONS = 'SAVE_TRANSLATIONS';
export const CLEAR_TRANSLATIONS = 'CLEAR_TRANSLATIONS';
export const CLEAR_REDUCERS = 'CLEAR_REDUCERS';
/* Action which don't change state */
export const TRANSLATIONS_NO_CHANGE = 'TRANSLATIONS_NO_CHANGE';
